
		<div class="btn-group btn-group-toggle" data-toggle="buttons">
			<button
				type="button"
				class="btn btn-default"
				*ngFor="let option of options; let i = index"
				[ngClass]="[
					i === activeOptionIndex ? 'active' : ''
				]"
				(click)="toggleActive(i)"
			>
				{{ option }}
			</button>
		</div>
	